var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Remove"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 2.40759C5.445 2.40759 2.57143 5.28116 2.57143 8.83616C2.57143 12.3912 5.445 15.2647 9 15.2647C12.555 15.2647 15.4286 12.3912 15.4286 8.83616C15.4286 5.28116 12.555 2.40759 9 2.40759ZM9 13.979C6.165 13.979 3.85714 11.6712 3.85714 8.83616C3.85714 6.00116 6.165 3.69331 9 3.69331C11.835 3.69331 14.1429 6.00116 14.1429 8.83616C14.1429 11.6712 11.835 13.979 9 13.979ZM11.3079 5.62188L9 7.92974L6.69214 5.62188L5.78571 6.52831L8.09357 8.83616L5.78571 11.144L6.69214 12.0504L9 9.74259L11.3079 12.0504L12.2143 11.144L9.90643 8.83616L12.2143 6.52831L11.3079 5.62188Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.522c53cdd98f7ac72f7fa426d62d28c6.svg";
export { ForwardRef as ReactComponent };